import React from 'react'
import { DeliveryHourRow } from './deliveryHourRow'
import PropTypes from 'prop-types'

export const DeliveryHourRows = ({ row, dayName }) =>
  row === null
    ? <tr/>
    : <tbody>{
      row.poolTimes.map((poolTime, index) => {
        return <DeliveryHourRow key={`readDeliveryHours_${dayName}${index}`} row={row} dayName={dayName} index={index}/>
      })
    }</tbody>

DeliveryHourRows.propTypes = {
  row: PropTypes.shape({
    poolTimes: PropTypes.arrayOf(PropTypes.shape({
      startTime: PropTypes.string,
      endTime: PropTypes.string
    })).isRequired
  }),
  dayName: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/deliveryHours/deliveryHourRows.js